import React, { useState, useEffect } from "react";
import { Modal, Select, DatePicker, InputNumber, TreeSelect } from "antd";
import moment from "moment";
const { TreeNode } = TreeSelect;
const { Option } = Select;

export const BudgetModal = ({
  title,
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
  categories,
}) => {
  const tags = [
    "Me",
    "For Family",
    "For Child",
    "For Friends",
    "For Consultant",
  ];
  const frequnecy = ["Weekly", "Monthly", "Quaterly", "Annually"];
  // const categories = [
  //   "Shopping",
  //   "Groceries",
  //   "Fast Food",
  //   "Traveling",
  //   "Fruit",
  // ];
  return (
    <div>
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <h3 className="modaltitle">{title}</h3>
        <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">Category</h3>
         <TreeSelect
              showSearch
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              placeholder="Choose Category"
              allowClear
              // treeDefaultExpandAll
              value={data && data.categoryName}
              onChange={(value, label,extra) => {
                const selectedNode = extra.triggerNode;
              const parentNode = selectedNode && selectedNode.props.label;
              const selectedCategory = parentNode ? `${value}-${parentNode}` : value;
              console.log("selectedCategory",selectedCategory);
              handleChange("category", selectedCategory);
              }}
            >
            {categories && categories.map(category => {
              let parentLabel = category.categoryName;
              return (
                <TreeNode key={category.id} value={category.categoryName} title={category.categoryName} >
                  {category.subCategories.map((subCategory, index) => (
                    <TreeNode key={`${category.id}-${index}`} value={subCategory.name} title={subCategory.name} label={parentLabel} />
                  ))}
                </TreeNode>
              );
            })}
              </TreeSelect> 
         {/*  <Select
            showSearch
            placeholder="-Select-"
            value={data && data.categoryName}
            onChange={(value, id) => {
              console.log("value", value);
              handleChange("categoryName", value);
            }}
          >
            {categories &&
              categories.map((item, index) => (
                <Option key={index} value={item.categoryName}>
                  {item.categoryName}
                </Option>
              ))}
          </Select>  */}
        </div>
        {/*  <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">Frequency</h3>
          <Select
            showSearch
            placeholder="-Select-"
            value={data && data.frequncy}
            onChange={(value, id) => {
              console.log("value", value);
              handleChange("frequncy", value);
            }}
          >
            {frequnecy &&
              frequnecy.map((item, index) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              ))}
          </Select>
              </div> */}

        <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">Amount <span style={{ color: "red" }}>*</span></h3>
          <div className="inputWrapper" style={{ display: "flex" }}>
            <span
              style={{
                fontSize: "15px",
                padding: "8px",
                display: "flex",
                alignItems: "center",
                color: "rgba(0, 0, 0, 0.65)",
                background: "#fafafa",
                borderRadius: "4px",
                border:"1px solid #d1d5db"
              }}
            >
              $
            </span>
            <InputNumber
              step={1}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              className="Input"
              placeholder="Amount"
              name="amount"
              value={data && data.amount}
              id="amount"
              onChange={(value) => {
                handleChange("amount", value);
              }}
            />
          </div>
          {/*
          <input
            className="roleInput"
            placeholder="Amount"
            name="amount"
            value={data && data.amount}
            id="amount"
            onChange={(e) => {
              e.preventDefault();
              handleChange(e.target.name, e.target.value);
            }}
          /> */}
        </div>
        {/* <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">Start Date</h3>
          <DatePicker
            style={{
              width: "100%",
              border: "1px solid #d1d5db",
              borderRadius: "5px",
            }}
            size="large"
            format={"MM/DD/YYYY"}
            placeholder="Start Date"
            name="startDate"
            value={data && data.startDate && moment(data.startDate)}
            id="newDate"
            onChange={(date, dateString) => {
              handleChange("startDate", dateString);
            }}
          />
        </div>
          */}
        <div style={{ marginBottom: "8px" }}>
          <h3 className="inputTitle">End Date</h3>
          <DatePicker
            style={{
              width: "100%",
              border: "1px solid #d1d5db",
              borderRadius: "5px",
            }}
            size="large"
            format={"MM/DD/YYYY"}
            placeholder="End Date"
            name="endDate"
            value={data && data.endDate && moment(data.endDate)}
            id="newDate"
            onChange={(date, dateString) => {
              handleChange("endDate", dateString);
            }}
          />
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={!data || !data.amount}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
